import { create } from 'zustand';
import type { CustomerInfo, Timeslot } from '@/types';

interface ReservationStore {
  // Form data
  date: Date | null;
  people: number;
  children: number;
  selectedTimeslot: Timeslot | null;
  customerInfo: CustomerInfo;

  // Actions
  setDate: (date: Date | null) => void;
  setPeople: (people: number) => void;
  setChildren: (children: number) => void;
  setTimeslot: (slot: Timeslot | null) => void;
  setCustomerInfo: (info: Partial<CustomerInfo>) => void;
  reset: () => void;
}

const initialCustomerInfo: CustomerInfo = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  specialOccasion: '',
  dietaryRestrictions: [],
  note: '',
};

const initialState = {
  date: null,
  people: 2,
  children: 0,
  selectedTimeslot: null,
  customerInfo: initialCustomerInfo,
};

export const useReservationStore = create<ReservationStore>((set) => ({
  ...initialState,

  setDate: (date) => set({ date }),

  setPeople: (people) => set({ people }),

  setChildren: (children) => set({ children }),

  setTimeslot: (slot) => set({ selectedTimeslot: slot }),

  setCustomerInfo: (info) =>
    set((state) => ({
      customerInfo: { ...state.customerInfo, ...info },
    })),

  reset: () => set(initialState),
}));
